import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ConceptData } from "../types";

export const editConcept = (payload: ConceptData) => {
   return apiClient<ApiResponse>("/v1/concept", {
      method: "PUT",
      body: payload
   })
}
